import React from 'react';
import './App.css';

const offices = [
  {
    name: 'Bukhari Commercial Office',
    address: 'Floor 3, Building 1C, Lane 6, Bukhari Commercial, DHA Phase 6, Karachi',
    map: 'https://www.google.com/maps?q=Floor%203%2C%20Building%201C%2C%20Lane%206%2C%20Bukhari%20Commercial&output=embed',
    link: 'https://maps.app.goo.gl/TuRmEySyrtRhvTUf6',
  },
  {
    name: 'Sindhi Muslim Society Office',
    address: 'E 13 B, Lane No 3, Gulistan-E-Zafar, Sindhi Muslim Society Block B, Karachi',
    map: 'https://www.google.com/maps?q=24.854366,67.058670&output=embed',
    link: 'https://www.google.com/maps?q=24.854366,67.058670',
  },
  {
    name: 'Saddar Chambers',
    address: '504 Paradise Chambers, Near Passport Office, Saddar, Karachi',
    map: 'https://www.google.com/maps?q=504%20Paradise%20Chambers%2C%20Near%20Passport%20Office%2C%20Saddar&output=embed',
    link: 'https://maps.app.goo.gl/nLiWJuYfEpVLXFoF7',
  },
];

function Contact() {
  return (
    <main className="contact">
      <section className="section-head">
        <p className="eyebrow">Contact</p>
        <h2>Let us know what needs attention and we will respond within one business day.</h2>
        <p>
          Share a short brief, attach supporting documents if available, and choose your preferred meeting format—virtual,
          in-office, or on-site.
        </p>
      </section>

      <section className="contact-grid">
        <article className="panel">
          <h3>Direct Lines</h3>
          <p className="muted">Click on a number to contact on WhatsApp.</p>
          <p>
            <a className="phone-link" href="https://wa.me/923343161042" target="_blank" rel="noopener noreferrer">
              +92 334 316 1042
            </a>
            <br />
            <a className="phone-link" href="https://wa.me/923343161041" target="_blank" rel="noopener noreferrer">
              +92 334 316 1041
            </a>
          </p>
          <p>
            Email: <strong>irfanharoon@irfanharoonassociates.com</strong>
            <br />
            <strong>vatao4@hotmail.com</strong>
            <br />
            <strong>vatao4@gmail.com</strong>
          </p>
  
          <div className="hours-card">
            <p>Monday – Saturday · 9:00 AM – 8:00 PM</p>
            <p>Sunday · Closed (urgent hearings only)</p>
          </div>
        </article>

      </section>

      <section className="offices">
        <p className="eyebrow">Visit us</p>
        <div className="offices-list">
          {offices.map(({ name, address, map, link }) => (
            <div key={name} className="office">
              <h3>{name}</h3>
              <p>{address}</p>
              <div className="map-wrapper">
                <iframe title={name} src={map} allowFullScreen loading="lazy" />
                <a className="map-overlay" href={link} target="_blank" rel="noopener noreferrer" aria-label={`Open ${name} in Google Maps`} />
              </div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}

export default Contact;
